<template>
    <div>
        <h3 v-if=meta.submenuTitle class="fw-bold m-0 p-2 text-secondary d-flex d-md-block justify-content-center">
            {{ meta.submenuTitle}}
        </h3>
        <div class="nav flex-md-column justify-content-center">
            <template v-for="page in submenu" :key="page.meta.title">
                <router-link
                    :to="`${page.path}`"
                    :class="`link text-secondary text-decoration-none p-2 fs-md-base
                        ${$route.path.includes(page.path) ? 'bg-purple_100 rounded-2' : ''}`"
                    >
                        {{ page.meta.title }}
                </router-link>
            </template>
        </div>
    </div>
</template>

<script setup lang="ts">
import { GeneratedMenu } from '@/types';


defineProps<{
    submenu: GeneratedMenu[];
    meta: Partial<{ submenuTitle: string}>
}>();

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@use '@/styles/variables.scss';


.link:hover {
    background: variables.$purple_100;
    border-radius: 8px;
}

/* Small devices (767px and below) */
@media (max-width: 767px) {
.link:hover {
    background: variables.$purple_100;
    border-radius: 8px;
}


}
</style>
